export enum RuntimeStatus {
    Unknown = -1,
    Running,
    Completed,
    ContinuedAsNew,
    Failed,
    Canceled,
    Terminated,
    Pending
}
